import { apiGet } from './apiClient';
import type { TopTrader } from './useTopTraders';

export async function fetchTraderPnl(
    conditionId: string,
    accountId: string,
    startDate?: string,
    endDate?: string
): Promise<TopTrader | null> {
    const params = new URLSearchParams();
    if (startDate) params.append('from_ts', startDate);
    if (endDate) params.append('to_ts', endDate);

    const queryString = params.toString();
    const url = `/api/markets/${encodeURIComponent(conditionId)}/trader/${encodeURIComponent(accountId)}${queryString ? '?' + queryString : ''}`;

    try {
        return await apiGet<TopTrader>(url);
    } catch (err) {
        if (err instanceof Error && err.message.includes('404')) {
            return null;
        }
        throw err;
    }
}
